import { StyleSheet } from 'react-native';

import Layout from '../../../config/Layout';
import mobile from './mobile';
import desktop from './desktop';

const styles = Layout.isDesktop ? { ...mobile, ...desktop } : mobile;

export default StyleSheet.create(styles);
